/**
 * @generated SignedSource<<f5fed53b21ccb8787c472f490fa76a05>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
export type PipelineAccessLevels = "BUILD_AND_READ" | "MANAGE_BUILD_AND_READ" | "READ_ONLY" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type TeamRow_teamPipeline$fragmentType: FragmentType;
export type TeamRow_teamPipeline$data = {|
  +accessLevel: PipelineAccessLevels,
  +id: string,
  +permissions: {|
    +teamPipelineDelete: ?{|
      +allowed: boolean,
    |},
    +teamPipelineUpdate: ?{|
      +allowed: boolean,
    |},
  |},
  +pipeline: ?{|
    +id: string,
  |},
  +team: ?{|
    +description: ?string,
    +id: string,
    +members: ?{|
      +count: number,
    |},
    +name: string,
    +pipelines: ?{|
      +count: number,
    |},
    +slug: string,
  |},
  +$fragmentType: TeamRow_teamPipeline$fragmentType,
|};
export type TeamRow_teamPipeline$key = {
  +$data?: TeamRow_teamPipeline$data,
  +$fragmentSpreads: TeamRow_teamPipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamRow_teamPipeline",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accessLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Pipeline",
      "kind": "LinkedField",
      "name": "pipeline",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamPipelineConnection",
          "kind": "LinkedField",
          "name": "pipelines",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPipelinePermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamPipelineUpdate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamPipelineDelete",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamPipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "4f6c9163889188c52a6c7c89ddda144f";

module.exports = ((node/*: any*/)/*: Fragment<
  TeamRow_teamPipeline$fragmentType,
  TeamRow_teamPipeline$data,
>*/);
